import layout from 'views/layout/';

export default [
  {
    path: '/activity',
    component: layout,
    meta: {
      breadNotLink: true,
      breadText: '营销'
    },
    children: [
      {
        path: 'information',
        name: '信息发布',
        alias: '/Web/Article/list',
        component: () => import('views/information/list'),
        meta: {
          parentName: '信息发布'
        }
      },
      {
        path: 'addInformation',
        name: '添加信息',
        alias: '/Web/Article/add',
        component: () => import('views/information/add'),
        meta: {
          parentName: '添加信息'
        }
      },
      {
        path: 'editInformation/:id',
        name: '编辑信息',
        alias: '/Web/Article/edit',
        component: () => import('views/information/add'),
        meta: {
          parentName: '添加信息'
        }
      },
      {
        path: 'memberGroup',
        name: '会员分群',
        alias: '/Web/MemberGroup/list',
        component: () => import('views/activity/memberGroup'),
        meta: {
          parentName: '会员分群'
        }
      },
      {
        path: 'memberGroupAdd',
        name: '添加/编辑分群',
        component: () => import('views/activity/memberGroupAdd'),
        meta: {
          parentName: '会员分群'
        }
      },
      {
        path: 'pageConfig',
        name: '会员端页面配置',
        alias: '/web/pageDiy/diyList',
        component: () => import('views/system/miniProgramPageConfig'),
        meta: {
          parentName: '营销',
          breadText: '会员端自定义'
        },
        children: [
          {
            path: 'config',
            name: '配置',
            component: () =>
              import('views/system/miniProgramPageConfig/config'),
            meta: {
              parentName: '营销'
            }
          }
        ]
      },
      {
        path: 'verifyExpCard',
        alias: '/Web/Active/check_serial_num',
        name: '体验卡验证',
        component: resolve =>
          require(['views/activity/verifyExpCard'], resolve),
        meta: {
          parentName: '营销'
        }
      },
      {
        path: 'list',
        alias: '/Web/Activity/pc_get_activity_list',
        name: '活动列表',
        component: resolve => require(['views/activity/activityList'], resolve),
        meta: {
          parentName: '营销',
          breadText: '营销活动'
        },
        children: [
          {
            path: 'number',
            name: '报名信息',
            alias: '/Web/Activity/pc_activity_sign',
            component: () => import('views/activity/signNumberDetail'),
            meta: {
              parentName: '营销'
            }
          },
          {
            path: 'sellCardDetail',
            name: '购卡信息',
            alias: '/Web/Activity/sellcard_list',
            component: () => import('views/activity/sellCardDetail'),
            meta: {
              parentName: '营销'
            }
          },
          {
            path: 'useRecord',
            name: '参与信息',
            alias: '/Web/Activity/useRecord',
            component: () => import('views/activity/useRecord'),
            meta: {
              parentName: '营销'
            }
          },
          {
            path: 'receiveRecord',
            name: '领取信息',
            alias: '/Web/Activity/receiveRecord',
            component: () => import('views/activity/receiveRecord'),
            meta: {
              parentName: '营销'
            }
          },
          {
            path: 'detail',
            name: '活动详情',
            alias: '/Web/Activity/get_activity_info',
            component: () => import('views/activity/add'),
            meta: {
              parentName: '营销',
              breadText: '活动编辑'
            }
          }
        ]
      },
      {
        path: 'bonusList',
        name: '发红包',
        alias: '/Web/Bonus/get_bonus_list',
        component: () => import('views/activity/bonusList'),
        meta: {
          keepAlive: true,
          parentName: '营销'
        },
        children: [
          {
            path: 'bonusEdit/:bonusId',
            name: '红包编辑',
            component: () => import('views/activity/bonusEdit'),
            meta: {
              parentName: '营销'
            }
          },
          {
            path: 'bonusAdd',
            name: '红包添加',
            component: () => import('views/activity/bonusEdit'),
            meta: {
              parentName: '发红包'
            }
          },
          {
            path: 'bonusRecord/:bonusId',
            name: '领奖记录',
            component: () => import('views/activity/bonusRecord'),
            meta: {
              parentName: '发红包'
            }
          }
        ]
      },
      {
        path: 'discount',
        name: '折扣券',
        alias: '/Web/Coupon/coupon_list',
        component: () => import('views/activity/discount/list'),
        meta: {
          parentName: '营销'
        },
        children: [
          {
            path: 'edit',
            name: '折扣券设置',
            component: () => import('views/activity/discount/edit'),
            meta: {
              parentName: '营销',
              breadText: '编辑'
            }
          },
          {
            path: 'receive',
            name: '折扣券领取记录',
            component: () => import('views/activity/discount/receiveRecords'),
            meta: {
              parentName: '营销',
              breadText: '领取记录'
            }
          },
          {
            path: 'out',
            name: '折扣券发放记录',
            component: () => import('views/activity/discount/outRecords'),
            meta: {
              parentName: '营销',
              breadText: '发放记录'
            }
          }
        ]
      },
      {
        path: 'groupBuyList',
        name: '团购活动列表',
        alias: '/Web/Groupbuy/groupbuy_list',
        component: () => import('views/activity/groupBuy/index'),
        meta: {
          parentName: '营销'
        }
      },
      {
        path: 'groupBuyDetail',
        name: '拼团配置',
        component: () => import('views/activity/groupBuy/detail'),
        meta: {
          parentName: '营销'
        }
      }
    ]
  },
  {
    path: '/goods',
    component: layout,
    name: '营销',
    children: [
      {
        path: 'list',
        name: '商城管理',
        alias: '/Web/Goods/goods_list',
        component: () => import('views/goods/list'),
        meta: {
          keepAlive: true,
          parentName: '营销'
        }
      },
      {
        path: 'add',
        name: '商品添加',
        component: () => import('views/goods/add'),
        meta: {
          parentName: '营销'
        }
      },
      {
        path: 'edit/:goodsId',
        name: '商品编辑',
        component: () => import('views/goods/add'),
        meta: {
          parentName: '营销'
        }
      },
      {
        path: 'exchange',
        name: '兑换记录',
        alias: '/Web/Exchange/exchange_list',
        component: () => import('views/goods/exchange'),
        meta: {
          parentName: '营销'
        }
      }
    ]
  }
]
